<template>
  <section class="section_most pt-md-10 pt-4">
    <template v-if="!loading && items.length > 0">
      <v-container>
        <div class="text-center section-header">
          <h2 class="section-title">
            {{ $t("Mostpopular") }}
          </h2>
          <p class="section-subtitle">
            {{ $t("Check_out_thelatest") }}
          </p>
        </div>
        <v-row>
          <v-col cols="12" md="3" v-for="(ad, i) in items" :key="i">
            <Card
              :image="ad.attachment[0]"
              :title="ad.price"
              :subtitle="ad.estate_type+' '+ ad.ad_type"
              :city="ad.city"
              :date="ad.publish_date"
              :type="ad.estate_type"
              :idcard="ad.id"
              :userid="ad.user_id"
            ></Card>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <template v-else>
      <v-row v-if="loading">
        <v-col cols="12" v-for="n in 4" :key="n">
          <v-skeleton-loader class="mx-auto border-0" type="paragraph" />
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12" class="d-flex justify-center align-center">
          <div class="no-services-card">
            <p class="no-services-text">{{ $t('no_estates_now') }}</p>
          </div>
        </v-col>
      </v-row>
    </template>
  </section>

</template>
<script>
import Card from "../Card/Card.vue";
import crudDataService from "@/Services/crudDataService";

export default {
  components: {
    Card,
  },
  data() {
    return {
      items: [],
      options: [],
      listArray: [],
      loading: true,
    };
  },

  methods: {
    async mostpopuler() {
      this.loading = true;
      try {
        let response = await crudDataService.getAll(`ads`);
        this.listArray = response.data.data.sell.nearest;
        this.items = this.listArray.slice(0, 4);
        this.items.forEach((element) => {
          this.options = element.options;
        });
      } catch (e) {
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.mostpopuler();
  },
};
</script>
<style lang="scss" scoped>
.section_most {
  background: #ffffff;
  padding: 32px 0;
}

.section-header {
  margin-bottom: 32px;
}

.section-title {
  font-size: clamp(24px, 4vw, 32px);
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.section-subtitle {
  font-size: clamp(16px, 2.5vw, 20px);
  color: #666;
  font-weight: 400;
  margin: 0;
}

@media (min-width: 960px){
  .section_most .v-container {
    max-width: 1108px;
  }
}

@media (min-width: 1280px){
  .section_most .v-container {
    max-width: 1470px;
  }
}

.no-services-card {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 32px 0;
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px auto;
  border: 1px solid #e0e0e0;
}

.no-services-text {
  color: #666;
  font-size: clamp(18px, 3vw, 24px);
  font-weight: 500;
  margin: 0;
}

@media (max-width: 600px) {
  .section_most {
    padding: 24px 0;
  }
  
  .section-header {
    margin-bottom: 24px;
  }
}
</style>
